/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { Languages } from './Languages'
import { useIntl } from 'react-intl'

const HeaderUserMenu: FC = () => {
  const intl = useIntl()
  const { currentUser, logout } = useAuth()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={currentUser?.avatarLink} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.name} {currentUser?.surname}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>{currentUser?.typeName}</span>
            </div>
            <a href={`/user-management/users/${currentUser?.id}`} className='fw-bold text-muted text-hover-primary text-truncate fs-7'>
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          {intl.formatMessage({ id: 'USER.HEADER.MY_PROFILE' })}
        </Link>
      </div>

      <Languages userId={currentUser?.id} />

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          {intl.formatMessage({ id: 'USER.HEADER.SIGN_OUT' })}
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
